import {debounce, get} from 'lodash';
import moment from 'moment';
import template from './series-table.component.html';

const EVENT_TRACKING_NAME = 'seriesTable';
const EVENT_TRACKING_ACTIONS = {
  exportSelected: 'exportSelected',
  exportAll: 'exportAll',
  paginationChanged: 'paginationChanged',
}

class AssetSeriesTableController {
  constructor(gettextCatalog, $filter, TimezoneService, equipmentRepository) {
    'ngInject';

    this.gettextCatalog = gettextCatalog;
    this.$filter = $filter;
    this.TimezoneService = TimezoneService;
    this.equipmentRepository = equipmentRepository;
    //variables
    this.exportSelected = false;
    this.timeStampOrderBy = '-';
    //Pagination
    this.currentPage = 1;
    this.itemsPerPage = 15;
    this.maxSize = 1;
  }

  $onInit() {}
  $onDestroy() {}
  $onChanges(changes) {
    const {seriesData, assetSeries} = changes;
    // const r =(seriesData.currentValue.length || 0) !== (seriesData.previousValue.length || 0);
    if (seriesData && seriesData.currentValue) {
      this.selectedSeriesIds = this.getSeriesIdsForRetreivedData(seriesData.currentValue);
      this.timeValueDict = this.buildTimeValueDictionary(seriesData.currentValue);
      this.timeStamps = Object.keys(this.timeValueDict);
    }
    if (assetSeries && assetSeries.currentValue) {
      this.seriesDict = assetSeries.currentValue.reduce((seriesDict, series) => {
        seriesDict[series.id] = series;
        return seriesDict;
      }, {});
    }
  }
  getCsvFileName() {
    const time = moment().format('YY-MM-DDThh-mm-ss');
    return `data_export.${this.assetName || ''}${time}.csv`;
  }
  allCSVData() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportAll,
      assetName: this.assetName,
    });
    const allSeries = Object.keys(this.seriesDict);
    this.allDataExporting = true;
    return this.equipmentRepository
      .getEquipSeriesData(allSeries, [this.startRange, this.endRange])
      .then(
        response => {
          const timeseriesExportAllData = response.data || [];
          const seriesIds = this.getSeriesIdsForRetreivedData(timeseriesExportAllData);
          const timeValueDict = this.buildTimeValueDictionary(timeseriesExportAllData);
          this.error = false;
          return this.getCsvData(seriesIds, timeValueDict, this.seriesDict);
        },
        () => {
          this.error = true;
        }
      )
      .finally(() => {
        this.allDataExporting = false;
      });
  }
  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data }
    })
  }

  paginationChanged() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.paginationChanged,
      currentPage: this.currentPage
    })
  }


  //A dictionary where the key is the timestamp of the aggregated values from all series data
  buildTimeValueDictionary(seriesData = []) {
    const valueDict = seriesData.reduce((timeValueMap, item) => {
      const {series, data = []} = item;
      data.forEach(record => {
        //Check to see if a dictionary value for this timestamp exists else make the value as object
        if (!timeValueMap[record.t]) {
          timeValueMap[record.t] = {};
        }
        timeValueMap[record.t][series.id] = record.v;
      });
      return timeValueMap;
    }, {});
    return valueDict;
  }

  getSeriesIdsForRetreivedData(seriesData = []) {
    return seriesData.map(item => item.series.id);
  }

  showExport() {
    this.exportSelected = !this.exportSelected;
  }

  exportSelectedCsv() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportSelected,
      assetName: this.assetName,
    });
    return this.getCsvData(this.selectedSeriesIds, this.timeValueDict, this.seriesDict);
  }

  //====csv========
  getCsvData(seriesIds, timeValueDict, seriesDict) {
    let columnArray = []; //array of rows
    this.exportSelected = false;

    //Get the column headers

    let headerArray = [];

    headerArray.push('Asset Name');

    headerArray.push('Attributes');

    headerArray.push('TIMESTAMP');

    const headerSet = this.setCsvHeaderSet(seriesIds);

    headerArray = this.setCsvHeaderArray(headerSet, headerArray, seriesDict);

    columnArray.push(headerArray);

    //push the attributes
    columnArray = this.setCsvAssetInfoArray(columnArray, this.assetAttrs, this.assetName);

    //need to keep track of where to put the timeseries data so everything lines up
    columnArray = this.setCsvTimeSeriesData(columnArray, headerSet, timeValueDict, seriesDict);

    return columnArray;
  }
  setCsvHeaderSet(seriesIds = []) {
    const headerSet = {};
    seriesIds.forEach(seriesId => {
      headerSet[seriesId] = seriesId;
    });

    return headerSet;
  }
  setCsvHeaderArray(headerSet, headerArray = [], seriesDict = {}) {
    for (let seriesId in headerSet) {
      //Get the series info
      const series = seriesDict[seriesId] || {};
      const {attrs = {}, title} = series;
      const uom = attrs.uom ? `(${this.gettextCatalog.getString(attrs.uom)})` : '';
      const seriesColTitle = `${this.gettextCatalog.getString(title)} ${uom}` || seriesId;

      headerArray.push(seriesColTitle);
    }

    return headerArray;
  }

  setCsvAssetInfoArray(columnArray = [], attrs = {}, assetName) {
    //attrs will be in the second col after the name
    const attrsRows = Object.keys(attrs).map(attrKey => `${attrKey} : ${attrs[attrKey]}`);
    const [fistAttr, ...rest] = attrsRows;

    columnArray.push([assetName, fistAttr]);
    rest.forEach(attr => {
      columnArray.push(['', attr]);
    });

    return columnArray;
  }
  /**
   * return ready csv array
   * @param {*} columnArray
   * @param {*} headerSet
   * @param {*} timeValueDict
   * @param {*} seriesDict
   */
  setCsvTimeSeriesData(columnArray, headerSet, timeValueDict, seriesDict) {
    let columnPushPosition = 1;
    let columnLength = columnArray.length; //need to get the length before we start pushing more

    let timestamps = Object.keys(timeValueDict); //get the timeStamps into an array so we can guarentee the sort order when iterating.

    const timeStampsReversed = timestamps.sort().reverse();

    timeStampsReversed.forEach(timestamp => {
      const rowArray = []; //so time series data does not go under Asset Name or Attributes.

      //push the timestamp
      rowArray.push(this.TimezoneService.tagToUserTimezone(timestamp));

      const dataDict = timeValueDict[timestamp];

      for (let seriesId in headerSet) {
        // get the current series to use it in the filter
        let series = seriesDict[seriesId];
        rowArray.push(this.$filter('attrsValueTranslate')(dataDict[seriesId], series, true));
      }
      if (columnPushPosition < columnLength) {
        columnArray[columnPushPosition].push([...rowArray]);
        columnPushPosition++;
      } else {
        columnArray.push(['', '', ...rowArray]);
      }
    });
    // columnArray = columnArray.forEach((row =>{
    //   const[name,attr]=row;
    //   row =
    // });
    return columnArray;
  }
}

export default {
  template,
  controller: AssetSeriesTableController,
  //not useing vm as when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'tableVm',
  bindings: {
    seriesData: '<',
    loadingData: '<',
    startRange: '<',
    endRange: '<',
    assetName: '<',
    assetAttrs: '<',
    assetSeries: '<'
  }
};
